module.exports = __webpack_public_path__ + "static/media/aboutme.a1ff6aa3.png";